import { IEdition } from 'src/interfaces/Edition';
import { IFormEdition } from 'src/interfaces/Edition';
import EditionEditorForm from 'src/pages/Dashboard/Editions/forms/EditionEditorForm';
import EditorDialogShell from 'src/common/components/modals/EditorDialogShell';
import { DialogProps } from '@mui/material/Dialog';
import { useTranslation } from 'react-i18next';

interface Props extends Omit<DialogProps, 'title'> {
  handleClose: () => void;
  handleSave: (editedEdition: IFormEdition, id?: string) => void;
  editionToEdit?: IEdition;
}

const EditionEditorModal = ({ id, open, handleClose, handleSave, editionToEdit }: Props) => {
  const { t } = useTranslation();
  const title = editionToEdit
    ? t('editions.editEditionModalTitle', { year: `${editionToEdit.year}` })
    : t('editions.addEditionModalTitle');

  return (
    <EditorDialogShell
      id={id ?? 'edition-editor'}
      open={open}
      onClose={handleClose}
      title={title}
      maxWidth="md"
    >
      <EditionEditorForm
        handleSave={handleSave}
        handleClose={handleClose}
        editionToEdit={editionToEdit}
      />
    </EditorDialogShell>
  );
};

export default EditionEditorModal;
